import { Link } from "react-router-dom";
import { Anchor } from "lucide-react";

export function TrustFooter({ showTrustSection = true }: { showTrustSection?: boolean }) {
  return (
    <>
      {showTrustSection && (
      <section className="py-20 bg-background">
        <div className="container mx-auto px-6 max-w-3xl text-center">
          <h2 className="text-2xl font-bold text-foreground mb-6">
            A note on how HostCaptain works
          </h2>
          <div className="text-muted-foreground space-y-4">
            <p>HostCaptain is built to:</p>
            <ul className="space-y-2">
              <li>• Reduce guesswork</li>
              <li>• Shorten time-to-decision</li>
              <li>• Help you act with confidence</li>
            </ul>
            <p className="mt-6">
              You can start free, upgrade when it helps, and cancel anytime.
            </p>
            <p className="font-medium text-foreground mt-4">
              No feature bloat. No forced upsells. Just clearer decisions.
            </p>
            <p className="mt-4">
              Want to see how it works? Explore our <Link to="/docs/getting-started-dashboard" className="text-primary hover:underline">getting started guides</Link>.
            </p>
          </div>
        </div>
      </section>
      )}

      {/* Footer */}
      <footer className="bg-navy text-white py-12">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center gap-2 mb-4 md:mb-0">
              <Anchor className="h-6 w-6 text-accent" />
              <span className="font-bold">HostCaptain</span>
            </div>
            <div className="flex gap-8 text-sm text-white/60">
              <Link to="/" className="hover:text-white transition-colors">Home</Link>
              <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
              <Link to="/auth" className="hover:text-white transition-colors">Login</Link>
            </div>
          </div>
          <div className="mt-6 text-center text-xs text-white/40">
            By using HostCaptain, you agree to our{" "}
            <Link to="/privacy" className="hover:text-white/60 underline">Privacy Policy</Link> and{" "}
            <Link to="/terms" className="hover:text-white/60 underline">Terms of Service</Link>.
          </div>
          <div className="mt-4 pt-4 border-t border-white/10 text-center text-sm text-white/40">
            © {new Date().getFullYear()} HostCaptain. All rights reserved.
          </div>
        </div>
      </footer>
    </>
  );
}
